import React, { useState, useEffect } from 'react';
import { Dropdown } from 'telstra-ui/components/drop-down/Dropdown';
import { Checkbox } from 'telstra-ui/components/checkbox/Checkbox';
import { Button } from 'telstra-ui/components/button/Button';
import { Tag } from 'telstra-ui/components/tag/Tag';
import './wireless-filters.css';

const WirelessFilters = (props) => {
  const {
    authorableContent: {
      filterHeading,
      filterSelectPlans,
      filterServiceHeading,
      filter5G,
      filterVoice,
      filterData,
      filterApply,
      filterCancel,
      filterCurrentDeviceText,
      filterCurrentDeviceBelowText,
      currentPlan,
    },
    filterOpen,
    filterApplied,
    applyFilter,
    cancelFilter,
    filterClearAll,
    currentPlanList,
    currentDevicesList,
  } = props;

  const [currentPlanSearch, setCurrentPlanSearch] = useState([]);
  const [currentDeviceSearch, setCurrentDeviceSearch] = useState([]);

  const [fiveGCheck, setFiveGCheck] = useState(false);
  const [voiceCheck, setVoiceCheck] = useState(false);
  const [dataCheck, setDataCheck] = useState(false);

  const [currentPlanSearchSelected, setCurrentPlanSearchSelected] = useState([]);
  const [currentDeviceSearchSelected, setCurrentDeviceSearchSelected] = useState([]);

  useEffect(() => {
    setCurrentPlanSearch(currentPlanList);
    setCurrentDeviceSearch(currentDevicesList);
  }, [currentPlanList, currentDevicesList]);

  useEffect(() => {
    if (filterClearAll) {
      setCurrentPlanSearchSelected([]);
      setCurrentDeviceSearchSelected([]);
      setFiveGCheck(false);
      setVoiceCheck(false);
      setDataCheck(false);
    }
  }, [filterClearAll]);

  const selectCurrentPlanSearchOption = (event) => {
    const selectedDevice = event.target.getAttribute('data-item');
    const deviceText = currentPlanList.find(itm => itm.itemId === selectedDevice);
    if (deviceText && currentPlanSearchSelected.includes(deviceText.displayText) === false) {
      const selectedDevices = [...currentPlanSearchSelected, deviceText.displayText];
      setCurrentPlanSearchSelected(selectedDevices);
    }
  };

  const selectCurrentDeviceSearchOption = (event) => {
    const selectedDevice = event.target.getAttribute('data-item');
    const deviceText = currentDevicesList.find(itm => itm.itemId === selectedDevice).displayText;
    if (currentDeviceSearchSelected.includes(deviceText) === false) {
      const selectedDevices = [...currentDeviceSearchSelected, deviceText];
      setCurrentDeviceSearchSelected(selectedDevices);
    }
  };

  const removeFilterSelectionCurrentPlan = (val) => {
    const currentDevices = currentPlanSearchSelected.filter(itm => itm !== val);
    setCurrentPlanSearchSelected(currentDevices);
  };

  const removeFilterSelectionCurrentDevice = (val) => {
    const currentDevices = currentDeviceSearchSelected.filter(itm => itm !== val);
    setCurrentDeviceSearchSelected(currentDevices);
  };

  const searchPlanBox = (event, dropDownOptions, planSearch) => {
    const searchText = event.target.value.toLowerCase();
    const desiredText = searchText.replace(/[-[\]`~@#%!'=_&";:/.>,<{}()*+?.,\\^$|#]/g);
    const options = dropDownOptions.filter((option) => {
      const optionText = option.displayText.toLowerCase();
      const match = optionText.match(desiredText);
      if (match != null && match.index !== undefined) {
        return true;
      }
      return false;
    });
    planSearch(options);
  };

  const changeCheckbox = (event) => {
    const checkBoxId = event.target.id;
    const checkedValue = event.target.checked;
    if (checkBoxId === 'filter-5g-checkbox') {
      if (checkedValue) {
        setFiveGCheck(false);
      }
      setFiveGCheck(checkedValue);
    } else if (checkBoxId === 'filter-voice-checkbox') {
      if (checkedValue) {
        setDataCheck(false);
      }
      setVoiceCheck(checkedValue);
    } else if (checkBoxId === 'filter-data-checkbox') {
      if (checkedValue) {
        setVoiceCheck(false);
      }
      setDataCheck(checkedValue);
    }
  };

  const onTagClose = (e) => {
    const idValue = e.target.parentNode.id;
    const [devType, devValue] = idValue.split('|');
    const filterObj = {};

    if (devType === 'currentPlan') {
      const currentPlans = currentPlanSearchSelected.filter(itm => itm !== devValue);
      setCurrentPlanSearchSelected(currentPlans);
      filterObj.currentPlanSelected = currentPlans;
    } else {
      filterObj.currentPlanSelected = currentPlanSearchSelected;
    }
    if (devType === 'currentDevice') {
      const currentDevices = currentDeviceSearchSelected.filter(itm => itm !== devValue);
      setCurrentDeviceSearchSelected(currentDevices);
      filterObj.currentDeviceValues = currentDevices;
    } else {
      filterObj.currentDeviceValues = currentDeviceSearchSelected;
    }
    if (devType === 'fiveG') {
      setFiveGCheck(false);
      filterObj.fiveGCheck = false;
    } else {
      filterObj.fiveGCheck = fiveGCheck;
    }
    if (devType === 'voiceCheck') {
      setVoiceCheck(false);
      filterObj.voiceCheck = false;
    } else {
      filterObj.voiceCheck = voiceCheck;
    }
    if (devType === 'dataCheck') {
      setDataCheck(false);
      filterObj.dataCheck = false;
    } else {
      filterObj.dataCheck = dataCheck;
    }
    if (filterObj.currentPlanSelected.length === 0 &&
      filterObj.currentDeviceValues.length === 0 &&
      !filterObj.fiveGCheck &&
      !filterObj.voiceCheck &&
      !filterObj.dataCheck
    ) {
      cancelFilter();
    } else {
      applyFilter(filterObj);
    }
  };

  const generateFilterTags = () => {
    let allTags = [];
    const currentPlans = currentPlanSearchSelected.map(dev => (
      {
        devType: 'currentPlan',
        devValue: dev,
      }
    ));
    allTags = [...allTags, ...currentPlans];

    const currentDevices = currentDeviceSearchSelected.map(dev => (
      {
        devType: 'currentDevice',
        devValue: dev,
      }
    ));
    allTags = [...allTags, ...currentDevices];

    if (fiveGCheck) {
      allTags.push({
        devType: 'fiveG',
        devValue: filter5G,
      });
    }
    if (voiceCheck) {
      allTags.push({
        devType: 'voiceCheck',
        devValue: filterVoice,
      });
    }
    if (dataCheck) {
      allTags.push({
        devType: 'dataCheck',
        devValue: filterData,
      });
    }
    return (
      allTags.map((tag, index) => (
        <div className="tag-box" key={`tag${index + 1}`}>
          <Tag
            label={tag.devValue}
            icon="icon-navigation-close"
            iconPosition="right"
            id={`${tag.devType}|${tag.devValue}`}
            onCloseClick={onTagClose}
          />
        </div>
      ))
    );
  };


  const applyFilterSelected = () => {
    const filterArr = {
      currentPlanSelected: currentPlanSearchSelected,
      currentDeviceValues: currentDeviceSearchSelected,
      fiveGCheck,
      voiceCheck,
      dataCheck,
    };
    applyFilter(filterArr);
  };

  const applyCancel = () => {
    setCurrentPlanSearchSelected([]);
    setCurrentDeviceSearchSelected([]);
    setFiveGCheck(false);
    setVoiceCheck(false);
    setDataCheck(false);
    cancelFilter();
  };

  return (
    <div className="wireless-filter-section">
      {filterOpen === false && filterApplied &&
        <div className="row">
          {generateFilterTags()}
        </div>
      }
      {filterOpen &&
        <div className="main-filter">
          <div className="row">
            <div className="col-12 heading20">
              {filterHeading}
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <Dropdown
                dropdownId="filter-current-plan"
                label={currentPlan}
                searchBox
                highlightSelected
                multiSelection
                assistiveText={filterSelectPlans}
                options={currentPlanSearch}
                values={currentPlanSearchSelected}
                onOptionClick={selectCurrentPlanSearchOption}
                removeFilterSelection={removeFilterSelectionCurrentPlan}
                searchOnChange={e => searchPlanBox(e, currentPlanList, setCurrentPlanSearch)}
              />
            </div>
            <div className="col-6">
              <Dropdown
                dropdownId="filter-current-device"
                label={filterCurrentDeviceText}
                multiSelection
                searchBox
                highlightSelected
                assistiveText={filterCurrentDeviceBelowText}
                options={currentDeviceSearch}
                values={currentDeviceSearchSelected}
                onOptionClick={selectCurrentDeviceSearchOption}
                removeFilterSelection={removeFilterSelectionCurrentDevice}
                searchOnChange={e => searchPlanBox(e, currentDevicesList, setCurrentDeviceSearch)}
              />
            </div>
            <div className="col-6">
              <div className="row">
                <div className="col-12 heading16">
                  {filterServiceHeading}
                </div>
                <div className="col-3">
                  <Checkbox
                    id="filter-voice-checkbox"
                    onChange={changeCheckbox}
                    checked={voiceCheck}
                    label={filterVoice}
                  />
                </div>
                <div className="col-3">
                  <Checkbox
                    id="filter-data-checkbox"
                    onChange={changeCheckbox}
                    checked={dataCheck}
                    label={filterData}
                  />
                </div>
                <div className="col-6">
                  <Checkbox
                    id="filter-5g-checkbox"
                    onChange={changeCheckbox}
                    checked={fiveGCheck}
                    label={filter5G}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row buttons-row" >
            <div className="col-3 offset-9">
              <div className="row">
                <div className="col-6">
                  <Button
                    variant="secondary"
                    size="small"
                    onClick={() => applyCancel()}
                  >{filterCancel}
                  </Button>
                </div>
                <div className="col-6">
                  <Button
                    variant="primary"
                    size="small"
                    state="app"
                    onClick={() => applyFilterSelected()}
                  >{filterApply}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default WirelessFilters;
